import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/cp4i-demohub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ArticleDetails from '../../gatsby-theme-carbon/components/ArticleDetails';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ArticleDetails name="Ty Harris, Ravi Katikala" lastUpdated="March 2021" readTimeMinutes="120" mdxType="ArticleDetails" />
    <h1>{`Coming Soon`}</h1>
    <p><strong parentName="p">{`Confluent Product Enablement`}</strong></p>
    <p><a parentName="p" {...{
        "href": "Confluent"
      }}>{`Lab 1 : Confluent Operator Installation`}</a></p>
    <p><a parentName="p" {...{
        "href": "Confluent"
      }}>{`Lab 2 : Configuring and run Schema registry`}</a></p>
    <p><a parentName="p" {...{
        "href": "Confluent"
      }}>{`Lab 3 : Configure and run KSQL`}</a></p>
    <p><a parentName="p" {...{
        "href": "Confluent"
      }}>{`Lab 4 : Configure and run Kafka Connect`}</a></p>
    <p><a parentName="p" {...{
        "href": "Confluent"
      }}>{`Lab 5: CP4I and Confluent`}</a></p>
    <p><a parentName="p" {...{
        "href": "Confluent"
      }}>{`Lab 6: Advanced - Security, Replicator, Monitoring`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      